import React from "react";
import { useI18n } from "../lib/i18n";

export const KIND_COLOR = {
  ante_mortem: "#4A7C59",
  post_mortem: "#1F3A5F",
  ante: "#4A7C59",
  post: "#1F3A5F",
};

export function KindBadge({ kind, className = "" }) {
  const { t } = useI18n();
  const isAnte = kind === "ante" || kind === "ante_mortem";
  const c = isAnte ? KIND_COLOR.ante : KIND_COLOR.post;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 font-body text-[11px] font-semibold ${className}`}
      style={{ background: `${c}14`, color: c, border: `1px solid ${c}55` }}
      data-testid={`kind-badge-${isAnte ? "ante" : "post"}`}
    >
      {isAnte ? t("kind.ante") : t("kind.post")}
    </span>
  );
}
